import { useState, useEffect, useMemo } from 'react';
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {END_DATE, getColor,getDates, START_DATE} from '../../../utility';
import moment from 'moment';
import ChartComponent from '../../../components/chart';
import { toast } from 'react-toastify';
import "../../../assets/css/scroll-table.css";
import { Row, Col, DatePicker, Button, Drawer } from 'antd';
import dayjs from 'dayjs';
import { SearchOutlined } from '@ant-design/icons';

function AppMonetization(){
  const navigate = useNavigate();
  const app  = useSelector((state) => state.app.data);

  const [monetizations,setMonetizations]  = useState([]);
  const [startDate,setStartDate] = useState(moment().subtract(START_DATE, 'days'));
  const [endDate,setEndDate] = useState(moment().subtract(END_DATE, 'days'));
  const [dataset,setDataset] = useState({
  	labels : [],
  	datasets : []
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);
  
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  
  const { code, os } = useParams();
  let dates = getDates(startDate,endDate);
  
  const { RangePicker } = DatePicker;
  const rangePickerValue = useMemo(() => [dayjs(startDate), dayjs(endDate)], [startDate, endDate]);

  const options = {
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Dollar'
        }
      },
    },
    responsive: true,
    maintainAspectRatio : false,
    interaction: {
      axis: 'x',
      mode: 'index',
      intersect: false,
    },
  };

  useEffect(() => {
    Api.get(`api/monetization?code=${code}&os=${os}&from=${startDate.format('YYYY-MM-DD')}&to=${endDate.format('YYYY-MM-DD')}`)
    .then(result => {
      if(result.data.code == 0)
        setMonetizations(result.data.data)
      else
        toast.error("Lỗi lấy dữ liệu !!");
      });
  }, [startDate,endDate,code,os]);

  useEffect(() => {
  	let datasets = transformData(monetizations);
    setDataset({
		  labels : dates,
		  datasets: datasets,
		})
  }, [monetizations]);

  const handleChangeDate = (values) => {
    if (Array.isArray(values) && values[0] && values[1]) {
      setStartDate(moment(values[0].toDate()));
      setEndDate(moment(values[1].toDate()));
    }
  };

	function transformData(monetizations) {
    let results = monetizations.map((i,k) => {
	  	return i.name == 'Total' ? {
        backgroundColor: getColor(k),
        borderColor: getColor(k),
        borderWidth: 2,
        data : dates.map((i1,k1) =>  parseFloat(i.values[i1] || 0)),
        fill: false,
        label : i.name,
        type : 'line',
      } : {
        backgroundColor: getColor(k),
	  		data : dates.map((i1,k1) =>  parseFloat(i.values[i1] || 0)),
        label : i.name,
        line : 'bar',
        maxBarThickness: 25
	  	}
	  });
    return results;
	}

  return (
    <>
    {/* Mobile: floating toggle to open filter drawer */}
    <div className="mobile-search-toggle" style={{ 
      display: 'none',
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 1000
    }}>
      <Button
        type="primary"
        shape="circle"
        icon={<SearchOutlined />}
        onClick={() => setDrawerOpen(true)}
        style={{
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          position: 'relative'
        }}
      />
    </div>

    <section className="main__filter" >
      <div className="filter">
        <div className="container-fluid">
          <form action="" method="get" id="form">
            <div className="row justify-content-between align-items-center">
              <div className="col-md-10">
                <div className="title-head-box">
                  <p className="title-block">Overview</p>
                </div>
              </div>
              <div className="col-md-2 desktop-filter">
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <div className="filter-sticky">
                    <div className="d-flex justify-content-end">
                      <RangePicker
                        value={rangePickerValue}
                        onChange={handleChangeDate}
                        style={{ width: '100%' }}
                        allowClear={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <section className="main__content">
      <div className="container-fluid">
        <div className="detail-body">
          <div className="overview_content pd-20">
            <div className="mb-4">
              <div className="row">
                
              </div>
            </div>
            <div className="mb-10">
            	<div className="row">
						    <div className="col-md-12">
						      <div className="box box--chart">
						        <div className="box__content">
						        	<ChartComponent type="bar" data={dataset} options={options} height={330} />
						        </div>
						      </div>
						    </div>
						  </div>
            </div>
            <div className="mb-4">
              <div className="table-report-wrapper">
                <table className="table-report table table-bordered text-center">
                  <thead>
                    <tr>
                      <th className="fixed-column"></th>
                      {dates.map((i, k) => (
                        <th key={`h${i}`}>{i}</th>
                      ))}
                      <th>AVG</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {monetizations.map((i, k) => (
                      <tr key={`tr-${k}`}>
                        <td className="fixed-column">{i.name}</td>
                        {dates.map((i1, k1) => (
                          <td key={`${k}-${i1}`}>{parseFloat(i.values[i1] || 0).toFixed(2)}</td>
                        ))}
                        <td>{i.avg}</td>
                        <td>{i.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    {/* Mobile: Drawer with filters */}
    <Drawer
      title="Search Filters"
      placement="right"
      onClose={() => setDrawerOpen(false)}
      open={drawerOpen}
      width={320}
      className="mobile-filter-drawer"
      zIndex={2500}
    >
      <div className="mb-10">
        <Row gutter={[12, 12]}>
          <Col xs={24}>
            <div style={{ marginBottom: 4 }}>Date range:</div>
            <RangePicker
              value={rangePickerValue}
              onChange={handleChangeDate}
              style={{ width: '100%' }}
              allowClear={false}
              getPopupContainer={(trigger) => trigger.parentNode}
              dropdownClassName="drawer-date-dropdown"
            />
          </Col>
        </Row>
      </div>
    </Drawer>
    
    <style>{`
      @media (max-width: 768px) {
        .main__filter { display: none !important; }
        .desktop-filter { display: none !important; }
        .mobile-search-toggle { display: block !important; }
        .mobile-filter-drawer .ant-drawer-body { padding: 10px !important; }
        .mobile-filter-drawer .drawer-date-dropdown { max-width: 100% !important; }
        .mobile-filter-drawer .drawer-date-dropdown .ant-picker-panels { flex-direction: column !important; }
      }
      @media (min-width: 769px) {
        .mobile-search-toggle { display: none !important; }
        .desktop-filter { display: block !important; }
      }
    `}</style>
    </>
  );
}
export default AppMonetization;